export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("fodindin_user"));
  } catch {
    return null;
  }
};

export const saveUser = (user) => localStorage.setItem("fodindin_user", JSON.stringify(user));

export const clearUser = () => localStorage.removeItem("fodindin_user");

export const formatFCFA = (n) => `${n.toLocaleString("fr-FR")} FCFA`;

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

// --- Parrainage : mémorise le membre dont le partage/QR a amené le visiteur (7 jours) ---
const CLE_PARRAIN = "fodindin_parrainage";

export const saveParrainage = (parrainId, annonceId) => {
  if (!parrainId) return;
  localStorage.setItem(
    CLE_PARRAIN,
    JSON.stringify({ parrain_id: parrainId, annonce_id: annonceId, le: Date.now() }),
  );
};

export const getParrainage = () => {
  try {
    const p = JSON.parse(localStorage.getItem(CLE_PARRAIN));
    if (!p?.parrain_id) return null;
    if (Date.now() - (p.le || 0) > 7 * 24 * 3600 * 1000) return null; // lien périmé
    return p;
  } catch {
    return null;
  }
};

export const clearParrainage = () => localStorage.removeItem(CLE_PARRAIN);
